import { useAuth0 } from "@auth0/auth0-react";
import { Button, Col, Row } from "antd";
import { FC } from "react";

const UserProfile: FC = () => {
  const { user, logout } = useAuth0();

  return (
    <Row justify="center">
      <Col>
        <Row>
          <Col>Hello {user?.name}</Col>
        </Row>
        <Row>
          <Col>
            <Button
              onClick={() => {
                logout({ returnTo: window.location.origin });
              }}
            >
              Log out
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default UserProfile;
